import { render } from "./Tags.vue?vue&type=template&id=716638b8&scoped=true"
import script from "./Tags.vue?vue&type=script&lang=js"
export * from "./Tags.vue?vue&type=script&lang=js"

import "./Tags.vue?vue&type=style&index=0&id=716638b8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-716638b8"

export default script